module.exports = __webpack_public_path__ + "static/img/bg_activity3.b8643a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/bg_activity3.png
// module id = bOQ+
// module chunks = 1